// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "label[data-v-3dac6025]{font-weight:bold}", "",{"version":3,"sources":["webpack://./src/pages/search/form/ParallelSourceAndTargets.vue"],"names":[],"mappings":"AAEA,uBAAA,gBAAA","sourcesContent":["\n\nlabel { font-weight: bold; }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
